import { RefObject, useEffect } from 'react';

export const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  callback: (event: MouseEvent) => void,
  // Listen in the capture phase. Needed when the click target lives inside a
  // component that stops event propagation (e.g. the React Flow canvas), which
  // would otherwise prevent a bubble-phase document listener from ever firing.
  useCapture = false,
) => {
  const handleClick = (e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      // check if target has class MuiTooltip-tooltip
      (window as any).test = e.target as HTMLElement;
      // console.log('TEEEE', (e.target as HTMLElement).parentNode(e.target as HTMLElement).parentNode?.parentNode);
      if ((e.target as HTMLElement).classList.contains('MuiTooltip-tooltip')) {
        return;
      }
      if ((e.target as HTMLElement).getAttribute('role') === 'tooltip') {
        return;
      }
      if ((e.target as HTMLElement).parentElement?.parentElement?.classList.contains('select__clear-indicator')) {
        return;
      }
      callback(e);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick, useCapture);
    return () => {
      document.removeEventListener('mousedown', handleClick, useCapture);
    };
  }, []);
};

type EventListener = {
  event: keyof HTMLElementEventMap;
};

export const useEventListeners = (listeners: EventListener[], callback: (event: Event | MouseEvent) => void) => {
  useEffect(() => {
    listeners.forEach(({ event }) => {
      document.addEventListener(event, callback);
    });

    return () => {
      listeners.forEach(({ event }) => {
        document.removeEventListener(event, callback);
      });
    };
  }, []);
};
